// extracted by mini-css-extract-plugin
module.exports = {"Stopwatch":"Stopwatch_Stopwatch__3lLaU","Hidden":"Stopwatch_Hidden__3Omnv"};